import { TextButton } from '@riac/design-system';
import styled from 'styled-components';

export const FilterMenuContainer = styled.div`
  @media print {
    display: none;
  }
  display: none;
  background-color: ${(props) => props.theme.black[10]};
  padding: 20px;
  min-width: 225px;
  width: 225px;
  ${(props) => props.theme.desktop} {
    display: block;
  }
  ${(props) => props.theme.extrawide} {
    min-width: 300px;
    width: 300px;
  }

  label, h5 {
    color: ${(props) => props.theme.black[90]};
  }
`;

interface IFilterBlock {
  isLoading: boolean;
}
export const FilterBlock = styled.div<IFilterBlock>`
  width: 100%;
  margin-top: 28px;

  h5 {
    font-variant-caps: inherit;
    font-family: sans-serif;
    border-bottom: solid 1px ${(props) => props.theme.black[90]};
    margin-bottom: 2rem;
  }
  
  li {
    list-style: none;
  }
  ${(props) => (props.isLoading ? 'min-height: 300px;' : '')}

  ${TextButton} {
    font-size: 1.8rem;
  }
`;

export const SubcategoryFilterBlock = styled.div`
  padding-left: 15px;
`;

export const CollectionsButton = styled(TextButton)`
  font-size: inherit;
`;
